<template>
  <div class="landing">
    <BoardMiddle :readonly="true" />
  </div>
</template>

<script>
import BoardMiddle from '@/components/pages/board/Floating/BoardMiddle.vue'

export default {
  components: { BoardMiddle },
  data () {
    return {
      
    }
  }
}
</script>

<style scoped>

</style>
